import React, {Component} from 'react';

class SwitchFrame extends Component {
    render() {
        const {value} = this.props;

        return (
            <div className="react-select__value-image-container" data-testid={`${value}-game-type-option`}>
                <span className="text">{value.toUpperCase()}</span>
            </div>
        );
    }
}

export default SwitchFrame;
